<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="IMG"><span epub:type="pagebreak" id="pg_vi" title="vi"><img alt="image" height="705" src="images/interior-house-002_fmt.jpg" width="500"/></span></p>
<p class="SP-BRK" id="pt1"> </p>
<p class="PN"><span epub:type="pagebreak" id="pg_1" title="1"><span href="#/xhtml/contents#p_pt1" title="Link target outside of Sample"><span class="Billhead-1900">PART 1</span></span></span></p>
<p class="pt1"><span href="#/xhtml/contents#p_pt1" title="Link target outside of Sample"><span class="Barbaro-SC">THE</span> <span class="Barbaro-CAPS">H</span><span class="Barbaro-SC">OME</span> <span class="Barbaro-SC">FOR</span> <span class="Barbaro-CAPS">L</span><span class="Barbaro-SC">OST</span> <span class="Barbaro-CAPS">C</span><span class="Barbaro-SC">AUSES</span></span></p>
<p class="Dateline-Chapter-dl"><span class="Billhead-1900">OCTOBER 1855</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?5ffb8c59